import { useEffect } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAppStore } from './store/appStore';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import MainLayout from './components/layout/MainLayout';
import MindMapFlow from './pages/mindmap/MindMapFlow';
import AbnormalSalesApp from './pages/abnormal/AbnormalSalesApp';
import AdminBackendApp from './pages/admin/AdminBackendApp';
import AdminAuthApp from './pages/permissions/AdminAuthApp';
import { Spinner } from './components/common/Spinner';

/** Redirects authenticated users away from login pages. */
function GuestRoute() {
  // const user = useAppStore((s) => s.user);
  // const loading = useAppStore((s) => s.loading);
  //
  // if (loading) {
  //   return (
  //     <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  //       <Spinner />
  //     </div>
  //   );
  // }
  //
  // if (user) {
  //   return <Navigate to="/" replace />;
  // }

  return <Outlet />;
}

export default function App() {

  return (
    <Routes>
      {/* Public: login pages — redirect to / if already logged in */}
      <Route element={<GuestRoute />}>
        <Route path="/login-manual" element={<LoginPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
      </Route>

      {/* Protected: main app with shared layout — pages read batch state directly from store */}
      <Route element={<MainLayout />}>
        <Route index element={<Navigate to="/nj-highlight" replace />} />
        <Route path="nj-highlight" element={<MindMapFlow />} />
        <Route path="abnormal-sales" element={<AbnormalSalesApp />} />
        <Route path="admin-backend" element={<AdminBackendApp />} />
        <Route path="admin-panel" element={<AdminAuthApp />} />
      </Route>
    </Routes>
  );
}
